import React, { useState, useEffect } from "react";
import HistoryChart from "./HistoryChart";
import coinGecko from "../../assets/js/coinGecko";
import "./css/CoinDetails.css";

const CoinDetails = () => {
    const [coins, setCoins] = useState([])
    const [trxPrice, setTRXPrice] = useState("")
    const [coinHistory, setCoinHistory] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    let coinPercent;

    const formatData = data => {
        return data.map((el) => {

            return {
                x: el[0],
                y: el[1]
            }
        })
    }

    useEffect(() => {
        const fetchcoinDetails = async () => {
            setIsLoading(true)

            const [coinPriceData, trxPriceData, btcHistory, ethHistory, usdtHistory] = await Promise.all([
                coinGecko.get("/coins/markets", {
                    params: {
                        vs_currency: "inr",
                        ids: "bitcoin,ethereum,tether"
                    }
                }),
                coinGecko.get("/coins/markets", {
                    params: {
                        vs_currency: "inr",
                        ids: "tron"
                    }
                }),
                coinGecko.get(`/coins/bitcoin/market_chart/`, {
                    params: {
                        vs_currency: "inr",
                        days: "1",
                    }
                }),
                coinGecko.get(`/coins/ethereum/market_chart/`, {
                    params: {
                        vs_currency: "inr",
                        days: "1",
                    }
                }),
                coinGecko.get(`/coins/tether/market_chart/`, {
                    params: {
                        vs_currency: "inr",
                        days: "1",
                    }
                })
            ])
            setCoinHistory({
                btcHistory: formatData(btcHistory.data.prices),
                ethHistory: formatData(ethHistory.data.prices),
                usdtHistory: formatData(usdtHistory.data.prices)
            })
            setTRXPrice(trxPriceData.data[0].current_price)
            setCoins(coinPriceData.data)
            setIsLoading(false)

        }

        fetchcoinDetails()
    }, [])

    const renderCharts = () => {
        if (isLoading) {
            return <>Loading....</>
        }
        return (
            <>

                {coins.map(coin => {
                    if ((coin.price_change_percentage_24h).toFixed(2) < 0) {
                        coinPercent = <span className="coin-percent price-down">{(coin.price_change_percentage_24h).toFixed(2)}<i className="fas fa-arrow-down"></i></span>
                    } else {
                        coinPercent = <span className="coin-percent price-up">+{(coin.price_change_percentage_24h).toFixed(2)}<i className="fas fa-arrow-up"></i></span>
                    }
                    return (
                        <div className="col-12 col-md-6 col-lg-4" key={coin.id}>
                            <div className="coin-details">
                                <div className="coin-name">
                                    <img src={coin.image} alt={coin.id + "symbol"}></img>
                                    <span className="coin-name-span">{coin.symbol}</span>
                                </div>
                                <div className="coin-price">
                                    {(coin.current_price / trxPrice).toFixed(2)} CHY
                                    {coinPercent}
                                </div>
                            </div>
                            <div className="coin-chart">
                                <HistoryChart
                                    coinHistory={coin.id === "bitcoin" ? coinHistory.btcHistory : (coin.id === "ethereum" ? coinHistory.ethHistory : coinHistory.usdtHistory)}
                                    coinName={coin.id === "bitcoin" ? "BTC" : (coin.id === "ethereum" ? "ETH" : "USDT")}
                                    trxPrice={trxPrice}
                                />
                            </div>
                        </div>
                    )
                })}

            </>
        )
    }

    return (<>
        <div className="container">
            <div className="coin-charts">
                <div className="me-coin-data">
                    <div className="container">
                        <div className="row">
                            {renderCharts()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default CoinDetails;